import { DISCOVERY_SECTIONS, TRIFLAG_OPTIONS } from "@/lib/discovery";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export function DiscoveryFields({ value, onChange, readOnly = false }) {
  const v = value || {};
  const set = (k, val) => onChange({ ...v, [k]: val });
  const toggle = (k, opt) => {
    const arr = Array.isArray(v[k]) ? v[k] : [];
    set(k, arr.includes(opt) ? arr.filter((x) => x !== opt) : [...arr, opt]);
  };

  return (
    <div className="space-y-8">
      {DISCOVERY_SECTIONS.map((section) => (
        <div key={section.title} data-testid={`discovery-section-${section.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
          <p className="font-mono-data text-[10px] uppercase tracking-widest text-[#B54747] mb-3">{section.title}</p>
          <div className="grid sm:grid-cols-2 gap-4">
            {section.fields.map((f) => {
              const testid = `discovery-${f.key}`;
              const wide = f.type === "textarea" || f.type === "multiselect" ? "sm:col-span-2" : "";
              if (readOnly) {
                const display = Array.isArray(v[f.key]) ? (v[f.key].join(", ") || "—") : (v[f.key] || "—");
                return (
                  <div key={f.key} className={wide}>
                    <p className="text-xs text-zinc-500">{f.label}</p>
                    <p className="text-sm text-zinc-800 mt-0.5 whitespace-pre-wrap capitalize" data-testid={testid}>{display}</p>
                  </div>
                );
              }
              return (
                <div key={f.key} className={wide}>
                  <Label className="text-sm">{f.label}</Label>
                  {f.type === "text" && (
                    <Input value={v[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} data-testid={testid} className="mt-1 rounded-none" />
                  )}
                  {f.type === "textarea" && (
                    <Textarea value={v[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} rows={2} data-testid={testid} className="mt-1 rounded-none" />
                  )}
                  {f.type === "select" && (
                    <Select value={v[f.key] || ""} onValueChange={(val) => set(f.key, val)}>
                      <SelectTrigger className="mt-1 rounded-none" data-testid={testid}><SelectValue placeholder="Select…" /></SelectTrigger>
                      <SelectContent>
                        {f.options.map((o) => <SelectItem key={o} value={o} className="capitalize">{o.replace(/_/g, " ")}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  )}
                  {f.type === "triflag" && (
                    <div className="flex gap-1 mt-1" data-testid={testid}>
                      {TRIFLAG_OPTIONS.map((o) => (
                        <button
                          type="button"
                          key={o}
                          onClick={() => set(f.key, v[f.key] === o ? "" : o)}
                          data-testid={`${testid}-${o}`}
                          className={`px-3 py-1.5 text-xs font-mono-data uppercase border transition-colors ${v[f.key] === o ? "bg-[#0B1F33] text-white border-[#0B1F33]" : "border-zinc-300 text-zinc-600 hover:bg-zinc-100"}`}
                        >
                          {o}
                        </button>
                      ))}
                    </div>
                  )}
                  {f.type === "multiselect" && (
                    <div className="flex flex-wrap gap-2 mt-1">
                      {f.options.map((o) => {
                        const active = Array.isArray(v[f.key]) && v[f.key].includes(o);
                        return (
                          <button
                            type="button"
                            key={o}
                            onClick={() => toggle(f.key, o)}
                            className={`px-2.5 py-1 text-xs border text-left transition-colors ${active ? "bg-[#174A7E] text-white border-[#174A7E]" : "border-zinc-300 text-zinc-600 hover:bg-zinc-100"}`}
                          >
                            {o}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
